import React, { useState, useContext,useEffect } from "react";
import { Box, CardContent, Input, Button, Typography } from "@mui/material";

import { pageSourceService, cypressLocatorsAPI,CagLocatorsGeneration } from "../../../services/webServices";
import { useNavigate, useLocation } from "react-router-dom";
// import Locators from './Locators';  // Import the Locators component
import CommonAccordion from "../../custom-components/CommonAccordion";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import MessagePopup from "../../popup-components/MessagePopup";
import { handleProgressBar } from "../../custom-components/ProgressBar/ProgressBarWithAPI";

const validatePageSource = (pageSource) => {
  if (!pageSource || typeof pageSource !== "string") {
    return "Invalid input: Page source must be a string.";
  }

  const trimmedSource = pageSource.trim();
  if (!trimmedSource.startsWith("<") || !trimmedSource.endsWith(">")) {
    return "Invalid Page Source: Must start with '<' and end with '>'.";
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(trimmedSource, "text/html");
  const parserErrors = doc.querySelectorAll("parsererror");

  if (parserErrors.length > 0) {
    return "Invalid HTML Structure: Parsing failed. Please check your tags and structure.";
  }

  if (!doc.querySelector("html") || !doc.querySelector("body")) {
    return "Page source is missing <html> or <body> tags.";
  }

  return null; // Valid
};

const InputForm = ({ setPageSource, framework }) => {
  const [pageSourceInput, setPageSourceInput] = useState("");
  // const [locatorsData, setLocatorsData] = useState([]); // To store generated locators data
  // const [showLocators, setShowLocators] = useState(false); // State to control visibility of Locators
  const navigate = useNavigate();
  const location = useLocation();
  const { setLoadingState } = useContext(LoadingModalContext);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  // const { pseudoCode, locators } = useContext(TestCaseFlowDataContext);
  const defaultFeatureFilesExpanded =
    true && !Object.keys(location.state?.generatedLocators ?? {}).length > 0;

    useEffect(() => {
      // Clear locators data when page source input changes
      // setLocatorsData([]);
      console.log("Page source input changed, clearing locators data.",framework);
      
    }, []);
  const handleUserStoryChange = (e) => {
    setPageSourceInput(e.target.value);
  };

  const handleGenerateLocators = async () => {
    const validationError = validatePageSource(pageSourceInput);
    if (validationError) {
      setPopupMessage(validationError);
      setPopupOpen(true);
      return;
    }
    setPageSource(pageSourceInput);

    const progressHandler = handleProgressBar({ setLoadingState, totalDurationMs: 18000 });
    progressHandler.start("Generating Locators");

    try {
      const requestData = { pageSource: pageSourceInput };
      // Use Cypress-specific API for Cypress framework, otherwise use generic API
      let generatedLocatorsResponse;
      if (framework === "cypress-javascript") {
        generatedLocatorsResponse = await cypressLocatorsAPI(requestData);
      } else {
        generatedLocatorsResponse = await CagLocatorsGeneration(requestData);
      }

      const generatedLocators = generatedLocatorsResponse.data;

      if (
        !generatedLocators ||
        typeof generatedLocators !== "object" ||
        Object.keys(generatedLocators).length === 0
      ) {
        setPopupMessage("Locators generation failed. Please provide proper page source.");
        setPopupOpen(true);
        return;
      }
      await progressHandler.finishAndClose();
      navigate(location.pathname, {
        state: {
          ...location.state,
          pageSource: pageSourceInput,
          generatedLocators: generatedLocators,
        },
        replace: true,
      });
    } catch (error) {
      console.error("Error generating locators:", error);
      const errorMsg =
        error?.response?.data?.Error ||
        error?.response?.data?.message ||
        "An error occurred. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      // Session expired handling removed as it's not used in this component
      setLoadingState({ open: false, message: "", progress: null });
    } finally {
      progressHandler.stop();
      setLoadingState({ open: false, message: "", progress: null });
    }
  };
  return (
    <Box>
      <CommonAccordion
        type={"output"}
        summary={"Introduce SUT"}
        details={
          <>
            <Box sx={{ color: "#2b2f30", marginBottom: 2 }}>
              <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
                Provide Page DOM</Typography>
              Include only relevant DOM elements to avoid inaccurate locators
              and unnecessary automation complexity.
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                // alignItems: 'center',
                // width: '100%',
                // marginTop: '50px',
              }}
            >
              <form>
                <CardContent
                  sx={{
                    // padding: 1,
                    width: 500,
                    bgcolor: "#E4E3E3",
                    borderRadius: 2,
                    marginBottom: 6,
                    // boxShadow: 3,
                  }}
                >
                  <Input
                    fullWidth
                    disableUnderline
                    multiline
                    minRows={5}
                    maxRows={10}
                    margin="dense"
                    placeholder="Enter Page Source"
                    value={pageSourceInput}
                    onChange={handleUserStoryChange}
                    autoComplete="off"
                    sx={{
                      color: "black",
                      bgcolor: "transparent",
                      padding: "10px 10px 10px 33px",
                    }}
                  />
                  <hr style={{ borderColor: "rgba(0, 0, 0, 0.12)" }} />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "end",
                      mt: 2,
                    }}
                  >
                    <Button
                      variant="contained"
                      startIcon={<GenerateButton />}
                      sx={{
                        mt: 0,
                        textTransform: "none",
                        backgroundColor: "#49A3FF",
                      }}
                      disabled={!pageSourceInput.trim()}
                      onClick={handleGenerateLocators} // Handle Generate Locators button click
                    >
                      Generate Locators
                    </Button>
                  </Box>
                </CardContent>
              </form>

              {/* Conditionally render the Locators accordion after the "Generate Locators" button is clicked */}
            </Box>
          </>
        }
        defaultExpanded={defaultFeatureFilesExpanded}
      />
      <MessagePopup
        modalOpen={popupOpen}
        okayHandler={() => setPopupOpen(false)}
        message={popupMessage}
      />

      {/* {showLocators && <Locators locatorsData={locatorsData} />} */}
    </Box>
  );
};

export default InputForm;
